import { Grid } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { MeasureDrillDownInfo, MetricDrillDownInfo } from "../../../../../../../../api/types/svTypes.ts";
import type { DrillDownState } from "../../../../hooks/useDrillDown";
import { selectDimensions } from "../../../../store/selectors/metaDataSelectors";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import PartContainer from "../../../viewer/common/PartContainer.tsx";
import AddCondition from "./AddCondition.tsx";
import DrillDownConditionsTree from "./conditions/DrillDownConditionsTree.tsx";
import { isMetricDrillDownInfo } from "./isMeasureDrillDownInfo.ts";

interface Props {
  state: DrillDownState;
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo | MetricDrillDownInfo;
}

export default function ConditionsPanel({ state, configuration, info }: Props) {
  const dimensions = useSelector(selectDimensions);

  const validDimensions = useMemo(() => {
    if (isMetricDrillDownInfo(info)) return dimensions;
    return info.allocated === true ? dimensions : dimensions.filter((d) => d.glAllowed === true);
  }, [info, dimensions]);

  if (!configuration || !info?.conditions || info.conditions.length === 0) {
    return <></>;
  }

  return (
    <PartContainer
      caption="Conditions"
      captionVariant="subtitle2"
      sx={{ width: "400px", p: "1.3rem", pl: 3, minHeight: 0 }}
      containerSx={{ width: "100%", gap: 1 }}
    >
      <Grid container sx={{ pt: 2, width: "100%", minHeight: 0 }}>
        <DrillDownConditionsTree
          conditions={state.conditionTree}
          canBeRemoved
          onRemoveField={state.actions.removeCondition}
          onFieldChanged={state.actions.updateCondition}
        />
      </Grid>
      <AddCondition
        text="Add Condition"
        conditions={state.conditions}
        dimensions={validDimensions}
        onAddField={state.actions.addCondition}
      />
    </PartContainer>
  );
}
